import { AddPeopleToMutationDocument } from "@pathwright/graphql-client/src/generated"

export default AddPeopleToMutationDocument
